import { render, staticRenderFns } from "./PageBannerSmall.vue?vue&type=template&id=1dca50ca&scoped=true&"
import script from "./PageBannerSmall.vue?vue&type=script&lang=js&"
export * from "./PageBannerSmall.vue?vue&type=script&lang=js&"
import style0 from "./PageBannerSmall.vue?vue&type=style&index=0&id=1dca50ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca50ca",
  null
  
)

export default component.exports